import TempMathImage from "../../../../images/category/math.jpg";
import TempScienceImage from "../../../../images/category/scienceAndNature.jpg";

export type Topic = DefaultTopic & {
  isDefault: boolean;
};

export type DefaultTopic = {
  uid: string;
  title: string;
  description: string;
  attachmentUrl: string;
};

export enum TopicFilter {
  All = "All",
  MyMix = "My Mix",
  DefaultTopics = "Default Topics",
}

export const DUMMY_DEFAULT_TOPICS: DefaultTopic[] = [
  {
    uid: "dummy1",
    title: "Math",
    description:
      "Math is the study of numbers, shapes, and patterns. It is a fundamental science that is used to understand the world around us. Math is used in many fields, including science, engineering, and technology.",
    attachmentUrl: TempMathImage,
  },
  {
    uid: "dummy2",
    title: "Science",
    description:
      "Science is the study of the structure and behavior of the physical and natural world through observation, experimentation, and the testing of theories. Science is used in many fields, including medicine.",
    attachmentUrl: TempScienceImage,
  },
];
